import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VisitorExportComponent } from './component/visitor-export.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule as MatTableModule } from '@angular/material/table';
import { DictionaryModule,  ApplicationClientCommonModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';

@NgModule({
  imports: [
    CommonModule,
    DictionaryModule,

    MatTableModule,
    MatSortModule,
    ReactiveFormsModule,
    FormsModule,
    ApplicationClientCommonModule,
    CommonTranslationModule
  ],
  declarations: [VisitorExportComponent]
})
export class VisitorExportModule { }
